// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3ub94","active":"downloadDropdown_active__24Q6g"};